module.exports = __webpack_public_path__ + "img/instagram.93325b6c.png";